// extracted by mini-css-extract-plugin
export default {"detailsList":"TrustAndSecurityCard_detailsList__lo7TN","codeValue":"TrustAndSecurityCard_codeValue__F-JIf"};